const pagoTpl =
`<!DOCTYPE html>
<html lang="es-MX">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>Formato de Pago - Línea de Captura</title>
<style>
  /* ===== Ajustes de impresión ===== */
  @page {
    size: A4;
    margin: 18mm;
  }
  * { box-sizing: border-box; }
  html, body { font-family: "Inter", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; color:#1a1a1a; }
  h1,h2,h3 { margin:0; }
  .wrap { max-width: 800px; margin: 0 auto; }

  /* ===== Encabezado ===== */
  .header {
    display:flex; align-items:center; gap:16px; border-bottom:2px solid #111; padding-bottom:12px; margin-bottom:16px;
  }
  .logo {
    width:72px; height:72px; border:1px solid #ddd; border-radius:10px; display:flex; align-items:center; justify-content:center;
    font-weight:700; font-size:12px;
  }

  .logo-img {
  width: 80px; /* ajusta el ancho deseado */
  height: auto; /* mantiene proporciones */
}



  .entidad h1 { font-size:20px; letter-spacing:.2px; }
  .entidad .sub { color:#666; font-size:12px; margin-top:2px; }
  .folio-box {
    margin-left:auto; text-align:right; font-size:12px;
  }
  .folio-box .lbl { color:#666; }
  .folio-box .val { font-weight:700; font-size:14px; }

  /* ===== Tarjeta ===== */
  .card {
    border:1px solid #ddd; border-radius:12px; padding:16px; margin-bottom:12px;
  }
  .grid-2 {
    display:grid; grid-template-columns: 1fr 1fr; gap:12px;
  }
  .grid-3 {
    display:grid; grid-template-columns: 1fr 1fr 1fr; gap:12px;
  }
  .field .label { font-size:11px; color:#666; margin-bottom:4px; }
  .field .value { font-size:14px; font-weight:600; }

  /* ===== Tabla de conceptos ===== */
  table {
    width:100%; border-collapse: collapse; font-size:13px; margin-top:6px;
  }
  thead th {
    background:#111; color:#fff; text-align:left; padding:8px; font-weight:700;
  }
  tbody td {
    border-bottom:1px solid #eee; padding:8px;
  }
  tfoot td {
    padding:8px; font-weight:700;
  }
  .right { text-align:right; }
  .muted { color:#666; }

  /* ===== Línea de captura ===== */
  .lc-card { display:flex; gap:16px; align-items:center; }
  .lc-block {
    flex:1; border:1px dashed #bbb; border-radius:12px; padding:14px;
    background: repeating-linear-gradient( -45deg, #fafafa, #fafafa 8px, #fff 8px, #fff 16px );
  }
  .lc-title { font-size:12px; color:#666; margin-bottom:6px; }
  .lc-value {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
    font-size:18px; letter-spacing:1px; word-spacing:8px; font-weight:800;
  }
  .lc-chips {
    margin-top:8px; display:flex; gap:6px; flex-wrap:wrap;
  }
  .chip {
    border:1px solid #ddd; border-radius:8px; padding:4px 8px; font-size:11px; color:#444; background:#fff;
  }
  .qr-box {
    width:110px; height:110px; border:1px solid #ddd; border-radius:10px; display:flex; align-items:center; justify-content:center;
    font-size:10px; color:#888;
  }

  /* ===== Pie ===== */
  .notes { font-size:11px; color:#555; line-height:1.45; }
  .divider { height:1px; background: #eee; margin:14px 0; }

  /* ===== Etiquetas de pago ===== */
  .pago-grid { display:grid; grid-template-columns: 1fr 1fr; gap:10px; }
  .pago-tag { background:#f7f7f7; border:1px solid #e6e6e6; border-radius:10px; padding:10px; }
  .pago-tag .k { font-size:11px; color:#666; }
  .pago-tag .v { font-weight:700; font-size:14px; }

  /* ===== Resaltado de total ===== */
  .total-box {
    margin-left:auto; max-width: 360px; border:2px solid #111; border-radius:12px; padding:12px;
  }
  .total-row { display:flex; justify-content:space-between; margin-top:8px; }
  .total-row .k { color:#444; }
  .total-row .v { font-weight:800; }

  /* ===== Footer legal ===== */
  .footer {
    margin-top:18px; font-size:10px; color:#666; display:flex; justify-content:space-between; gap:10px; align-items:center;
  }
  .barcode {
  border:1px solid #ddd; border-radius:6px; padding:6px;
  display:flex; align-items:center; justify-content:center;
  min-height:48px;
}
.barcode svg { width:100%; height:auto; }


  /* ===== Responsivo simple ===== */
  @media print {
    .qr-box { border:1px solid #aaa; }
    .barcode { border-color:#aaa; color:#666; }
  }
  @media (max-width:700px) {
    .grid-2, .grid-3, .pago-grid { grid-template-columns: 1fr; }
    .lc-card { flex-direction: column; align-items:stretch; }
    .total-box { max-width:100%; }
  }
</style>
</head>

<body>
  <div class="wrap">
    <!-- Encabezado -->
    <div class="header">

<div class="logo">
  <img src="https://totolac.gob.mx/contenidos/totolac/img/banner_2024_10_7_1728346730.2712.jpg" 
       alt="Logo Totolac" 
       class="logo-img">
</div>

        <div class="entidad">
        <h1>H. Ayuntamiento de Totolac</h1>
        <div class="sub">Sistema Administrativo de Totolac</div>
      </div>
      <div class="folio-box">
        <div class="lbl">Folio</div>
        <div class="val">{{FOLIO}}</div>
        <div class="lbl">Fecha de emisión</div>
        <div class="val">{{FECHA_EMISION}}</div>
      </div>
    </div>

    <!-- Datos del Contribuyente -->
    <div class="card">
      <div class="grid-2">
        <div class="field">
          <div class="label">Contribuyente / Razón Social</div>
          <div class="value">{{CONTRIBUYENTE}}</div>
        </div>
        <div class="field">
          <div class="label">RFC / CURP</div>
          <div class="value">{{RFC}}</div>
        </div>
      </div>
      <div class="grid-3" style="margin-top:10px;">
        <div class="field">
          <div class="label">Domicilio</div>
          <div class="value">{{DOMICILIO}}</div>
        </div>
      
        <div class="field">
          <div class="label">Correo de contacto</div>
          <div class="value">{{EMAIL}}</div>
        </div>
      </div>
    </div>

    <!-- Conceptos -->
    <div class="card">
      <h3>Conceptos</h3>
      <table>
        <thead>
          <tr>
            <th>Concepto</th>
            <th>Descripción</th>
            <th class="right">Importe</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{CONCEPTO_1}}</td>
            <td class="muted">{{DESCRIPCION_1}}</td>
            <td class="right">{{IMPORTE_1}}</td>
          </tr>
          <!-- Agrega más filas según sea necesario -->
        </tbody>
      </table>

      <div class="divider"></div>

      <div class="grid-2" style="align-items:start;">
        <div class="pago-grid">
          <div class="pago-tag">
            <div class="k">Periodo</div>
            <div class="v">{{PERIODO}}</div>
          </div>
          <div class="pago-tag">
            <div class="k">Vigencia de pago</div>
            <div class="v">{{VIGENCIA_PAGO}} <span class="muted">(hasta las 23:59 h)</span></div>
          </div>
        </div>

        <div class="total-box">
          <div class="total-row">
            <div class="k">Subtotal</div>
            <div class="v">{{SUBTOTAL}}</div>
          </div>
          <div class="total-row">
            <div class="k">Recargos</div>
            <div class="v">{{RECARGOS}}</div>
          </div>
          <div class="total-row">
            <div class="k">Descuentos</div>
            <div class="v">- {{DESCUENTOS}}</div>
          </div>
          <div class="divider"></div>
          <div class="total-row" style="font-size:18px;">
            <div class="k">TOTAL</div>
            <div class="v">{{TOTAL}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Línea de Captura -->
    <div class="card lc-card">
      <div class="lc-block">
        <div class="lc-title">LÍNEA DE CAPTURA</div>
      <div class="barcode">
  <svg id="barcode"></svg>
</div>
        <div class="lc-chips">
          <div class="chip">Banco de Preferencia: BBVA</div>
          <div class="chip">Referencia: {{REFERENCIA}}</div>
          <div class="chip">Convenio CIE: 002376067</div>
          <div class="chip">CIE Interbancario: 012914002023760674</div>

        </div>
      </div>
 
    </div>

    <!-- Instrucciones de pago -->
    <div class="card">
      <h3>Instrucciones de pago</h3>
      <ol class="notes">
        <li>Puede pagar en ventanilla bancaria o en banca en línea con la <strong>línea de captura</strong> indicada.</li>
        <li>Verifique que el <strong>monto total</strong> coincida antes de confirmar la operación.</li>
        <li>Una vez realizado el pago, la aplicación registrará el acuse de forma automática (puede tardar algunos minutos).</li>
      </ol>
    </div>

    <!-- Footer / Leyendas -->
    <div class="footer">
      <div>Generado el {{FECHA_EMISION}} por Sistema Administrativo de Totolac</div>


    </div>
  </div>
<!-- Librería (CDN) -->
<script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"></script>

<script>
  // Toma la línea de captura desde tu plantilla.
  // Si usas un motor de plantillas, esta variable ya vendrá reemplazada:
  const LINEA_CAPTURA = "{{LINEA_CAPTURA}}".trim();

  // Si prefieres leerla del bloque que ya la muestra:
  // const LINEA_CAPTURA = document.querySelector('.lc-value')?.textContent.trim() || '';

  // Genera el Code 128 (recomendado: soporta alfanumérico)
  if (LINEA_CAPTURA) {
    JsBarcode("#barcode", LINEA_CAPTURA, {
      format: "code128",
      lineColor: "#000",
      background: "transparent",
      width: 2,              // grosor de barras
      height: 48,            // altura en px (se imprime bien)
      displayValue: true,    // muestra el texto debajo
      fontSize: 12,
      margin: 0              // el contenedor ya tiene padding/border
    });
  } else {
    document.getElementById('barcode').outerHTML =
      '<div style="color:#888;font-size:12px;">[Línea de captura vacía]</div>';
  }
</script>


</body>
</html>`;

export default pagoTpl;

